import { TFileTypes } from '@interfaces/import/import';

import { EFileExtensions, EMIMETypes } from '@enums/common';
import { EDropzoneFileErrorCodes } from '@enums/dropzone';

import { MEGA_BYTE } from '@constants/common';

export const acceptedFileTypes: TFileTypes = {
	[EMIMETypes.pdf]: [EFileExtensions.pdf],
	[EMIMETypes.doc]: [EFileExtensions.doc],
	[EMIMETypes.docx]: [EFileExtensions.docx],
	[EMIMETypes.xlsx]: [EFileExtensions.xlsx],
	[EMIMETypes.xls]: [EFileExtensions.xls],
	[EMIMETypes.csv]: [EFileExtensions.csv],
	[EMIMETypes.png]: [EFileExtensions.png],
	[EMIMETypes.svg]: [EFileExtensions.svg],
	[EMIMETypes.jpeg]: [EFileExtensions.jpeg, EFileExtensions.jpg],
};

const MAX_MEGA_BYTES = 5;

export const MAX_BYTES = MAX_MEGA_BYTES * MEGA_BYTE;

const supportedExtensions = 'PDF, DOC, DOCX, XLSX, XLS, CSV, PNG, SVG, JPG, JPEG';

export const fileErrors = {
	[EDropzoneFileErrorCodes.fileInvalidType]: `Extension is not supported. Supports: ${supportedExtensions}`,
	[EDropzoneFileErrorCodes.fileTooLarge]: `File size is not allowed. Maximum size: ${MAX_MEGA_BYTES} MB`,
};

export const supportsText = `Supports: ${supportedExtensions}`;
